import ApiService from '@/services/core/api.service'

const AdminProductCategoryService = {
  async get (query) {
    return ApiService.get(`admin/product-categories?${query}`)
  }
}

export default AdminProductCategoryService
